// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_template_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ApprovalMode } from "../../bfftypes/v1/approval_flow_type_pb";
import { file_bfftypes_v1_approval_flow_type } from "../../bfftypes/v1/approval_flow_type_pb";
import type { ApprovalFlowStage } from "./approval_flow_model_pb";
import { file_bffuser_v1_approval_flow_model } from "./approval_flow_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_template_model.proto.
 */
export const file_bffuser_v1_workflow_template_model: GenFile = /*@__PURE__*/
  fileDesc("CihiZmZ1c2VyL3YxL3dvcmtmbG93X3RlbXBsYXRlX21vZGVsLnByb3RvEgpiZmZ1c2VyLnYxIkMKD1dvcmtmbG93Q2FzZVRhZxIYCgVsYWJlbBgBIAEoCUIJukgGcgQQARgUEhYKBWNvbG9yGAIgASgJQge6SARyAhABImAKFFdvcmtmbG93VGFnUG9vbEVudHJ5Eg0KBWxhYmVsGAEgASgJEg0KBWNvbG9yGAIgASgJEhcKD3JlZmVyZW5jZV9jb3VudBgDIAEoBRIRCglkZWxldGFibGUYBCABKAgimQUKEFdvcmtmbG93VGVtcGxhdGUSFwoCaWQYASABKAlCC7pICNgBAXIDsAEBEhcKBG5hbWUYAiABKAlCCbpIBnIEEAEYHhIYCgtkZXNjcmlwdGlvbhgDIAEoCUgAiAEBEjgKB3NlY3Rpb24YBSABKA4yGy5iZmZ1c2VyLnYxLldvcmtmbG93U2VjdGlvbkIKukgHggEEEAEgABITCgtpc19idWlsdF9pbhgHIAEoCBIwCgliaWdfc3RlcHMYCCADKAsyEy5iZmZ1c2VyLnYxLkJpZ1N0ZXBCCLpIBZIBAhAUEi4KCmNyZWF0ZWRfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYCiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhcKCmNyZWF0ZWRfYnkYCyABKAlIAYgBARIXCgp1cGRhdGVkX2J5GAwgASgJSAKIAQESOwoMZGVmYXVsdF90YWdzGA4gAygLMhsuYmZmdXNlci52MS5Xb3JrZmxvd0Nhc2VUYWdCCLpIBZIBAhAKEhgKEHJlcXVpcmVzX2JnX2NvZGUYDyABKAgSIwoNZGlzcGxheV9vcmRlchgQIAEoBUIHukgEGgIoAUgDiAEBEiUKHWFsbG93c19nZW5lcmF0aW9uX3RhcmdldF9jb2RlGBEgASgIQg4KDF9kZXNjcmlwdGlvbkINCgtfY3JlYXRlZF9ieUINCgtfdXBkYXRlZF9ieUIQCg5fZGlzcGxheV9vcmRlckoECAQQBUoECAYQB0oECA0QDlIIc2NoZWR1bGVSC3JlcG9ydF90eXBlUhpkZWZhdWx0X2Fzc2lnbmVlX21lbWJlcl9pZCKUAQoHQmlnU3RlcBIeCg1kaXNwbGF5X29yZGVyGAEgASgFQge6SAQaAigBEhgKBXRpdGxlGAIgASgJQgm6SAZyBBABGGQSMAoJc3ViX3N0ZXBzGAYgAygLMhMuYmZmdXNlci52MS5TdWJTdGVwQgi6SAWSAQIQHkoECAMQBEoECAQQBVILZGVzY3JpcHRpb25SBGljb24iwQYKB1N1YlN0ZXASHgoNZGlzcGxheV9vcmRlchgBIAEoBUIHukgEGgIoARIXCgRuYW1lGAIgASgJQgm6SAZyBBABGB4SIQoLZGVzY3JpcHRpb24YAyABKAlCB7pIBHICGGRIAIgBARJDChBsaW5rZWRfcGFnZV9raW5kGAQgASgOMhouYmZmdXNlci52MS5MaW5rZWRQYWdlS2luZEIIukgFggECEAFIAYgBARIrChNhc3NpZ25lZV9tZW1iZXJfaWRzGAYgAygJQg66SAuSAQgQZCIEcgIQARJBChBhcHByb3ZhbF9zZXR0aW5nGAcgASgLMiIuYmZmdXNlci52MS5TdWJTdGVwQXBwcm92YWxTZXR0aW5nSAKIAQESTAoaZGVtYW5kX2F1dG9fY29uZmlybV9tZXRob2QYCCABKA4yIy5iZmZ1c2VyLnYxLkRlbWFuZEF1dG9Db25maXJtTWV0aG9kSAOIAQESLAofcGxhbl9hdXRvX3N1Ym1pdF9vZmZzZXRfbWludXRlcxgJIAEoBUgEiAEBEjgKMGRpc2NhcmRfaW5jb21wYXRpYmxlX2luaGVyaXRlZF9hdXRvbWF0aW9uX2ZpZWxkcxgKIAEoCBJeCiBkZW1hbmRfYXV0b19jb25maXJtX290aGVyX21ldGhvZBgLIAEoDjIjLmJmZnVzZXIudjEuRGVtYW5kQXV0b0NvbmZpcm1NZXRob2RCCrpIB4IBBBABIABIBYgBARI9ChJwbGFuX2NyZWF0aW9uX3RpbWUYDCABKAsyHC5iZmZ1c2VyLnYxLlBsYW5DcmVhdGlvblRpbWVIBogBAUIOCgxfZGVzY3JpcHRpb25CEwoRX2xpbmtlZF9wYWdlX2tpbmRCEwoRX2FwcHJvdmFsX3NldHRpbmdCHQobX2RlbWFuZF9hdXRvX2NvbmZpcm1fbWV0aG9kQiIKIF9wbGFuX2F1dG9fc3VibWl0X29mZnNldF9taW51dGVzQiMKIV9kZW1hbmRfYXV0b19jb25maXJtX290aGVyX21ldGhvZEIVChNfcGxhbl9jcmVhdGlvbl90aW1lSgQIBRAGUhFsaW5rZWRfcGFnZV9sYWJlbCJuChBQbGFuQ3JlYXRpb25UaW1lEh4KC2RheXNfYmVmb3JlGAEgASgFQgm6SAYaBBgeKAASOgoKbG9jYWxfdGltZRgCIAEoCUImukgjciEyH14oWzAxXVswLTldfDJbMC0zXSk6WzAtNV1bMC05XSQihgEKFlN1YlN0ZXBBcHByb3ZhbFNldHRpbmcSMwoEbW9kZRgBIAEoDjIZLmJmZnR5cGVzLnYxLkFwcHJvdmFsTW9kZUIKukgHggEEEAEgABI3CgZzdGFnZXMYAiADKAsyHS5iZmZ1c2VyLnYxLkFwcHJvdmFsRmxvd1N0YWdlQgi6SAWSAQIQBSIbChlXb3JrZmxvd1RlbXBsYXRlRGVsZXRhYmxlIkAKKldvcmtmbG93VGVtcGxhdGVCbG9ja2VkQnlBdXRvQ3JlYXRpb25SdWxlcxISCgpydWxlX2NvdW50GAEgASgFKnIKEFdvcmtmbG93U2NoZWR1bGUSIQodV09SS0ZMT1dfU0NIRURVTEVfVU5TUEVDSUZJRUQQABIdChlXT1JLRkxPV19TQ0hFRFVMRV9SRUdVTEFSEAESHAoYV09SS0ZMT1dfU0NIRURVTEVfQ0hBTkdFEAIqkAIKD1dvcmtmbG93U2VjdGlvbhIgChxXT1JLRkxPV19TRUNUSU9OX1VOU1BFQ0lGSUVEEAASHQoZV09SS0ZMT1dfU0VDVElPTl9UT01PUlJPVxABEicKI1dPUktGTE9XX1NFQ1RJT05fREFZX0FGVEVSX1RPTU9SUk9XEAISGwoXV09SS0ZMT1dfU0VDVElPTl9XRUVLTFkQAxIcChhXT1JLRkxPV19TRUNUSU9OX01PTlRITFkQBBIbChdXT1JLRkxPV19TRUNUSU9OX0FOTlVBTBAFEhoKFldPUktGTE9XX1NFQ1RJT05fVE9EQVkQBhIfChtXT1JLRkxPV19TRUNUSU9OX1NJTkdMRV9EQVkQByrsBgoXRGVtYW5kQXV0b0NvbmZpcm1NZXRob2QSKgomREVNQU5EX0FVVE9fQ09ORklSTV9NRVRIT0RfVU5TUEVDSUZJRUQQABIsCihERU1BTkRfQVVUT19DT05GSVJNX01FVEhPRF9QUkVWX0RBWV9DT1BZEAESQwo/REVNQU5EX0FVVE9fQ09ORklSTV9NRVRIT0RfU0FNRV9XRUVLREFZX0NBVEVHT1JZX1BSRVZfV0VFS19DT1BZEAISMgouREVNQU5EX0FVVE9fQ09ORklSTV9NRVRIT0RfV0VJR0hURURfTU9WSU5HX0FWRxADEkEKPURFTUFORF9BVVRPX0NPTkZJUk1fTUVUSE9EX1NBTUVfV0VFS0RBWV9DQVRFR09SWV9XRUlHSFRFRF9BVkcQBBI6CjZERU1BTkRfQVVUT19DT05GSVJNX01FVEhPRF9TQU1FX1dFRUtEQVlfUFJFVl9XRUVLX0NPUFkQBRI2CjJERU1BTkRfQVVUT19DT05GSVJNX01FVEhPRF9BQ1RVQUxfVFJFTkRfQ09SUkVDVElPThAGEisKJ0RFTUFORF9BVVRPX0NPTkZJUk1fTUVUSE9EX0VYVEVSTkFMX0pXQRAHEjEKLURFTUFORF9BVVRPX0NPTkZJUk1fTUVUSE9EX0VYVEVSTkFMX0RFTUFORF9BSRAIEjEKLURFTUFORF9BVVRPX0NPTkZJUk1fTUVUSE9EX0VYVEVSTkFMX01FVEVSTElOSxAJEjAKLERFTUFORF9BVVRPX0NPTkZJUk1fTUVUSE9EX0VYVEVSTkFMX0xPQUROQVZJEAoSNAowREVNQU5EX0FVVE9fQ09ORklSTV9NRVRIT0RfRVhURVJOQUxfRU5TRU1CTEVfTEFCEAsSLgoqREVNQU5EX0FVVE9fQ09ORklSTV9NRVRIT0RfSU5fSE9VU0VfRU5HSU5FEAwSNAowREVNQU5EX0FVVE9fQ09ORklSTV9NRVRIT0RfV0VFS0xZX1BSRVZfV0VFS19DT1BZEA0SMAosREVNQU5EX0FVVE9fQ09ORklSTV9NRVRIT0RfTU9OVEhMWV9QTEFOX0NPUFkQDhI0CjBERU1BTkRfQVVUT19DT05GSVJNX01FVEhPRF9DU1ZfUkVHSVNURVJFRF9WQUxVRVMQDyq3DAoOTGlua2VkUGFnZUtpbmQSIAocTElOS0VEX1BBR0VfS0lORF9VTlNQRUNJRklFRBAAEiMKH0xJTktFRF9QQUdFX0tJTkRfV09SS0ZMT1dfQ0FTRVMQARItCilMSU5LRURfUEFHRV9LSU5EX0RFTUFORF9BQ1RVQUxfU1RBVElTVElDUxACEh8KG0xJTktFRF9QQUdFX0tJTkRfU1VQUExZX0dBUBAEEiUKIUxJTktFRF9QQUdFX0tJTkRfU1VQUExZX0JJTEFURVJBTBAFEi4KKkxJTktFRF9QQUdFX0tJTkRfQURNSU5fTk9USUZJQ0FUSU9OX0NIQU5HRRAGEiEKHUxJTktFRF9QQUdFX0tJTkRfU1VQUExZX1BMQU5UEAcSIgoeTElOS0VEX1BBR0VfS0lORF9TVVBQTFlfNDhEQVRBEAgSMAosTElOS0VEX1BBR0VfS0lORF9BRE1JTl9JTkRJUkVDVF9UUkFOU01JU1NJT04QCRIqCiZMSU5LRURfUEFHRV9LSU5EX1NVUFBMWV9SRU5FV19GT1JFQ0FTVBAKEiYKIkxJTktFRF9QQUdFX0tJTkRfQURNSU5fRklQX1BSRU1JVU0QCxIhCh1MSU5LRURfUEFHRV9LSU5EX0JJRERJTkdfU1BPVBAMEiUKIUxJTktFRF9QQUdFX0tJTkRfQklERElOR19JTlRSQURBWRANEiUKIUxJTktFRF9QQUdFX0tJTkRfQURNSU5fQklEX0xJTUlUUxAOEiQKIExJTktFRF9QQUdFX0tJTkRfUExBTl9TVUJNSVNTSU9OEA8SJQohTElOS0VEX1BBR0VfS0lORF9QTEFOX1BST0NVUkVNRU5UEBASIwofTElOS0VEX1BBR0VfS0lORF9QTEFOX0dFTl9TQUxFUxAREiwKKExJTktFRF9QQUdFX0tJTkRfUExBTl9ERU1BTkRfU1VQUFJFU1NJT04QEhIjCh9MSU5LRURfUEFHRV9LSU5EX0JBTEFOQ0VfREVNQU5EEBMSJwojTElOS0VEX1BBR0VfS0lORF9CQUxBTkNFX0dFTkVSQVRJT04QFBIlCiFMSU5LRURfUEFHRV9LSU5EX1JFVkVOVUVfRk9SRUNBU1QQFRIkCiBMSU5LRURfUEFHRV9LSU5EX1JFVkVOVUVfSU5WT0lDRRAWEiUKIUxJTktFRF9QQUdFX0tJTkRfV0VBVEhFUl9GT1JFQ0FTVBAXEioKJkxJTktFRF9QQUdFX0tJTkRfREVNQU5EX0ZPUkVDQVNUX0RBSUxZEBgSHgoaTElOS0VEX1BBR0VfS0lORF9EQVNIQk9BUkQQGRImCiJMSU5LRURfUEFHRV9LSU5EX0NVU1RPTUVSX0NPTlRSQUNUEBoSIgoeTElOS0VEX1BBR0VfS0lORF9DVVNUT01FUl9SQVRFEBsSJgoiTElOS0VEX1BBR0VfS0lORF9DVVNUT01FUl9TQ0hFRFVMRRAcEioKJkxJTktFRF9QQUdFX0tJTkRfU1VCTUlTU0lPTl9NQU5BR0VNRU5UEB0SKAokTElOS0VEX1BBR0VfS0lORF9ERU1BTkRfU0lOR1VMQVJfREFZEB4SLgoqTElOS0VEX1BBR0VfS0lORF9CQUxBTkNFX0lNUFVUQVRJT05fUE9MSUNZEB8SJgoiTElOS0VEX1BBR0VfS0lORF9QTEFOX1NQTElUX1NVUFBMWRAgEiIKHkxJTktFRF9QQUdFX0tJTkRfQURNSU5fVVBMT0FEUxAhEiAKHExJTktFRF9QQUdFX0tJTkRfQURNSU5fT0NDVE8QIhIoCiRMSU5LRURfUEFHRV9LSU5EX0FETUlOX0VTTEpfQUNDT1VOVFMQIxIyCi5MSU5LRURfUEFHRV9LSU5EX0FETUlOX1dFQVRIRVJfRk9SRUNBU1RfUE9JTlRTECQSKwonTElOS0VEX1BBR0VfS0lORF9DVVNUT01FUl9ERU1BTkRfR1JPVVBTECUSKAokTElOS0VEX1BBR0VfS0lORF9BRE1JTl9BUFBST1ZBTF9GTE9XECYSLgoqTElOS0VEX1BBR0VfS0lORF9CQUxBTkNFX0dFTkVSQVRJT05fREVUQUlMECcqjgEKG1dvcmtmbG93VGVtcGxhdGVFcnJvclJlYXNvbhIuCipXT1JLRkxPV19URU1QTEFURV9FUlJPUl9SRUFTT05fVU5TUEVDSUZJRUQQABI/CjtXT1JLRkxPV19URU1QTEFURV9FUlJPUl9SRUFTT05fSU5fVVNFX0JZX0FVVE9fQ1JFQVRJT05fUlVMRRABQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bfftypes_v1_approval_flow_type, file_bffuser_v1_approval_flow_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * WorkflowCaseTag is a user-defined label + color pair (色付きタグ). Mirrors
 * internalapi.v1.WorkflowCaseTag. Shared by WorkflowCase.tags and
 * WorkflowTemplate.default_tags. Defined here (rather than
 * workflow_case_model.proto) because workflow_case_model.proto already
 * imports this file, avoiding an import cycle. color values are validated
 * against the domain's fixed 8-color palette in the backend, not here.
 *
 * @generated from message bffuser.v1.WorkflowCaseTag
 */
export type WorkflowCaseTag = Message<"bffuser.v1.WorkflowCaseTag"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string color = 2;
   */
  color: string;
};

/**
 * Describes the message bffuser.v1.WorkflowCaseTag.
 * Use `create(WorkflowCaseTagSchema)` to create a new message.
 */
export const WorkflowCaseTagSchema: GenMessage<WorkflowCaseTag> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 0);

/**
 * WorkflowTagPoolEntry mirrors internalapi.v1.WorkflowTagPoolEntry
 * (workflow-tag-delete-ui design, Decision B/F). See the backend message
 * godoc for field semantics.
 *
 * @generated from message bffuser.v1.WorkflowTagPoolEntry
 */
export type WorkflowTagPoolEntry = Message<"bffuser.v1.WorkflowTagPoolEntry"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string color = 2;
   */
  color: string;

  /**
   * @generated from field: int32 reference_count = 3;
   */
  referenceCount: number;

  /**
   * @generated from field: bool deletable = 4;
   */
  deletable: boolean;
};

/**
 * Describes the message bffuser.v1.WorkflowTagPoolEntry.
 * Use `create(WorkflowTagPoolEntrySchema)` to create a new message.
 */
export const WorkflowTagPoolEntrySchema: GenMessage<WorkflowTagPoolEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 1);

/**
 * WorkflowTemplate is the root aggregate for a workflow template as exposed
 * to the BFF / frontend layer.
 *
 * @generated from message bffuser.v1.WorkflowTemplate
 */
export type WorkflowTemplate = Message<"bffuser.v1.WorkflowTemplate"> & {
  /**
   * id は Create RPC では client が知らない (= backend が UUID v7 で採番) ため空で送られる。
   * Update RPC では set されている必要があるが、 protovalidate の `ignore = IGNORE_IF_ZERO_VALUE` で
   * 「空文字 (= proto3 zero value) の場合は uuid validation を skip」 する。 set されている
   * ケースでは UUID 形式 check が走る。 nil UUID 拒否は backend handler / usecase で多層防御。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * section は必須。
   *
   * @generated from field: bffuser.v1.WorkflowSection section = 5;
   */
  section: WorkflowSection;

  /**
   * is_built_in indicates that this template is managed by the SaaS
   * operator. Tenant users may edit (overlay) or delete built-in
   * templates; deletion is a soft-delete (the overlay is persisted and
   * supersedes the SaaS-provided default).
   *
   * @generated from field: bool is_built_in = 7;
   */
  isBuiltIn: boolean;

  /**
   * @generated from field: repeated bffuser.v1.BigStep big_steps = 8;
   */
  bigSteps: BigStep[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string created_by = 11;
   */
  createdBy?: string;

  /**
   * @generated from field: optional string updated_by = 12;
   */
  updatedBy?: string;

  /**
   * default_tags are prefilled onto a case's tags when the case is created
   * from this template (spec workflow-templates.md AC-006). When empty, the
   * frontend falls back to the preset "定期"(blue)/"変更"(red) pair
   * (AC-TAG-002).
   *
   * @generated from field: repeated bffuser.v1.WorkflowCaseTag default_tags = 14;
   */
  defaultTags: WorkflowCaseTag[];

  /**
   * requires_bg_code is a backend-computed derived field (spec AC-003j,
   * workflow-bg-code-derivation design). Mirrors
   * internalapi.v1.WorkflowTemplate.requires_bg_code: true when at least one
   * sub-step links to a BG-requiring page (demand-forecast edit, procurement
   * plan, spot / intraday bidding — AC-WFW-003j). Read-only — the creation
   * dialog uses it to decide whether to show the BG code field and which
   * CreateWorkflowCasesRequest oneof member to send; it must never be sent
   * back in a Create / Update request.
   *
   * @generated from field: bool requires_bg_code = 15;
   */
  requiresBgCode: boolean;

  /**
   * display_order controls the global sort order of workflow templates within
   * an organization. 1-indexed; lower values appear first. Mirrors
   * internalapi.v1.WorkflowTemplate.display_order.
   *
   * @generated from field: optional int32 display_order = 16;
   */
  displayOrder?: number;

  /**
   * allows_generation_target_code is a backend-computed derived field (spec
   * AC-WFW-003j). Mirrors internalapi.v1.WorkflowTemplate.
   * allows_generation_target_code: true when the creation dialog may offer
   * 発電の計画提出者コード (ListWorkflowGenerationTargetCandidates) as BG code
   * candidates. Read-only.
   *
   * @generated from field: bool allows_generation_target_code = 17;
   */
  allowsGenerationTargetCode: boolean;
};

/**
 * Describes the message bffuser.v1.WorkflowTemplate.
 * Use `create(WorkflowTemplateSchema)` to create a new message.
 */
export const WorkflowTemplateSchema: GenMessage<WorkflowTemplate> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 2);

/**
 * BigStep is a top-level step group within a WorkflowTemplate.
 * See internalapi.v1.BigStep for field semantics.
 *
 * @generated from message bffuser.v1.BigStep
 */
export type BigStep = Message<"bffuser.v1.BigStep"> & {
  /**
   * @generated from field: int32 display_order = 1;
   */
  displayOrder: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: repeated bffuser.v1.SubStep sub_steps = 6;
   */
  subSteps: SubStep[];
};

/**
 * Describes the message bffuser.v1.BigStep.
 * Use `create(BigStepSchema)` to create a new message.
 */
export const BigStepSchema: GenMessage<BigStep> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 3);

/**
 * SubStep is a leaf-level task within a BigStep.
 * See internalapi.v1.SubStep for field semantics.
 *
 * @generated from message bffuser.v1.SubStep
 */
export type SubStep = Message<"bffuser.v1.SubStep"> & {
  /**
   * @generated from field: int32 display_order = 1;
   */
  displayOrder: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * linked_page_kind identifies the application page this sub-step links to.
   * UNSPECIFIED means no link is displayed. The frontend derives the URL and
   * label from this enum value via routePaths.
   *
   * @generated from field: optional bffuser.v1.LinkedPageKind linked_page_kind = 4;
   */
  linkedPageKind?: LinkedPageKind;

  /**
   * assignee_member_ids lists the eauth member_ids of the members (組織
   * メンバー) assigned to this sub-step (0..N, spec AC-WFT-010). Empty =
   * 担当者なし。「指定なし」 and real members are mutually exclusive in the
   * frontend UI only (spec AC-WFT-010d) — backend / DB do not distinguish
   * them; both are represented as an empty array.
   *
   * Field 6 was rewritten in-place from `optional string assignee_member_id`
   * to `repeated string assignee_member_ids` (issue #4550). This is a wire
   * breaking change (cardinality: optional -> repeated), but pre-release
   * + monorepo atomic deploy means no external v1 client exists to load
   * the old wire shape; producer and consumer rebuild from the same
   * commit. See docs/adr/workflow-substep-assignee-cardinality-array.md
   * for the DB-side rationale.
   *
   * @generated from field: repeated string assignee_member_ids = 6;
   */
  assigneeMemberIds: string[];

  /**
   * approval_setting mirrors internalapi.v1.SubStep.approval_setting. Absent
   * exactly when the linked page is スポット入札 / 時間前入札 (AC-WFT-010a).
   * On write (Create / Update), a non-bid sub-step sent without it is
   * rejected with INVALID_ARGUMENT and nothing is saved.
   *
   * @generated from field: optional bffuser.v1.SubStepApprovalSetting approval_setting = 7;
   */
  approvalSetting?: SubStepApprovalSetting;

  /**
   * Retained on a full template PUT even though this screen does not edit it.
   *
   * @generated from field: optional bffuser.v1.DemandAutoConfirmMethod demand_auto_confirm_method = 8;
   */
  demandAutoConfirmMethod?: DemandAutoConfirmMethod;

  /**
   * Submission offset in minutes (0..1440), edited on this screen only while the
   * sub-step links to 需要調達計画 / 発電販売計画 with approval mode 自動. A full
   * template PUT retains the loaded value otherwise.
   *
   * @generated from field: optional int32 plan_auto_submit_offset_minutes = 9;
   */
  planAutoSubmitOffsetMinutes?: number;

  /**
   * Write-only intent marker mirroring internalapi.v1.SubStep. It is not
   * returned from reads.
   *
   * @generated from field: bool discard_incompatible_inherited_automation_fields = 10;
   */
  discardIncompatibleInheritedAutomationFields: boolean;

  /**
   * @generated from field: optional bffuser.v1.DemandAutoConfirmMethod demand_auto_confirm_other_method = 11;
   */
  demandAutoConfirmOtherMethod?: DemandAutoConfirmMethod;

  /**
   * plan_creation_time mirrors internalapi.v1.SubStep.plan_creation_time
   * (spec AC-WFT-048): days before the target date and HH:mm in JST at which
   * the plan version is created. Absent = the section default.
   *
   * @generated from field: optional bffuser.v1.PlanCreationTime plan_creation_time = 12;
   */
  planCreationTime?: PlanCreationTime;
};

/**
 * Describes the message bffuser.v1.SubStep.
 * Use `create(SubStepSchema)` to create a new message.
 */
export const SubStepSchema: GenMessage<SubStep> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 4);

/**
 * PlanCreationTime mirrors internalapi.v1.PlanCreationTime. local_time is
 * restricted to 00:00..23:59 (spec AC-WFT-049).
 *
 * @generated from message bffuser.v1.PlanCreationTime
 */
export type PlanCreationTime = Message<"bffuser.v1.PlanCreationTime"> & {
  /**
   * @generated from field: int32 days_before = 1;
   */
  daysBefore: number;

  /**
   * @generated from field: string local_time = 2;
   */
  localTime: string;
};

/**
 * Describes the message bffuser.v1.PlanCreationTime.
 * Use `create(PlanCreationTimeSchema)` to create a new message.
 */
export const PlanCreationTimeSchema: GenMessage<PlanCreationTime> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 5);

/**
 * SubStepApprovalSetting mirrors internalapi.v1.SubStepApprovalSetting (spec
 * workflow-templates.md AC-WFT-010e / 010f). stage_order of each stage is
 * ignored on receipt (position is authoritative) and returned as 1..N.
 *
 * @generated from message bffuser.v1.SubStepApprovalSetting
 */
export type SubStepApprovalSetting = Message<"bffuser.v1.SubStepApprovalSetting"> & {
  /**
   * @generated from field: bfftypes.v1.ApprovalMode mode = 1;
   */
  mode: ApprovalMode;

  /**
   * @generated from field: repeated bffuser.v1.ApprovalFlowStage stages = 2;
   */
  stages: ApprovalFlowStage[];
};

/**
 * Describes the message bffuser.v1.SubStepApprovalSetting.
 * Use `create(SubStepApprovalSettingSchema)` to create a new message.
 */
export const SubStepApprovalSettingSchema: GenMessage<SubStepApprovalSetting> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 6);

/**
 * WorkflowTemplateDeletable mirrors internalapi.v1.WorkflowTemplateDeletable.
 *
 * @generated from message bffuser.v1.WorkflowTemplateDeletable
 */
export type WorkflowTemplateDeletable = Message<"bffuser.v1.WorkflowTemplateDeletable"> & {
};

/**
 * Describes the message bffuser.v1.WorkflowTemplateDeletable.
 * Use `create(WorkflowTemplateDeletableSchema)` to create a new message.
 */
export const WorkflowTemplateDeletableSchema: GenMessage<WorkflowTemplateDeletable> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 7);

/**
 * WorkflowTemplateBlockedByAutoCreationRules mirrors
 * internalapi.v1.WorkflowTemplateBlockedByAutoCreationRules (spec AC-WFT-061).
 *
 * @generated from message bffuser.v1.WorkflowTemplateBlockedByAutoCreationRules
 */
export type WorkflowTemplateBlockedByAutoCreationRules = Message<"bffuser.v1.WorkflowTemplateBlockedByAutoCreationRules"> & {
  /**
   * Number of rules that use the template (at least 1).
   *
   * @generated from field: int32 rule_count = 1;
   */
  ruleCount: number;
};

/**
 * Describes the message bffuser.v1.WorkflowTemplateBlockedByAutoCreationRules.
 * Use `create(WorkflowTemplateBlockedByAutoCreationRulesSchema)` to create a new message.
 */
export const WorkflowTemplateBlockedByAutoCreationRulesSchema: GenMessage<WorkflowTemplateBlockedByAutoCreationRules> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_template_model, 8);

/**
 * WorkflowSchedule classifies the workflow schedule type.
 * Renamed from WorkflowTemplateSchedule (context-free promotion so that both
 * workflow_template and workflow_case can share the enum without a
 * "Template" qualifier that only applies to the template side).
 * Mirrors internalapi.v1.WorkflowSchedule; kept context-local to
 * bffuser to allow independent evolution (promote to bfftypes/v1 when a
 * third consumer appears).
 *
 * @generated from enum bffuser.v1.WorkflowSchedule
 */
export enum WorkflowSchedule {
  /**
   * @generated from enum value: WORKFLOW_SCHEDULE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_SCHEDULE_REGULAR = 1;
   */
  REGULAR = 1,

  /**
   * @generated from enum value: WORKFLOW_SCHEDULE_CHANGE = 2;
   */
  CHANGE = 2,
}

/**
 * Describes the enum bffuser.v1.WorkflowSchedule.
 */
export const WorkflowScheduleSchema: GenEnum<WorkflowSchedule> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_template_model, 0);

/**
 * WorkflowSection classifies the operational period the workflow covers
 * (単日 / 週間 / 月間 / 年間; legacy 当日 / 翌日 / 翌々日 remain readable).
 * Renamed from WorkflowTemplateSection for the same reason as WorkflowSchedule.
 * Mirrors internalapi.v1.WorkflowSection.
 *
 * @generated from enum bffuser.v1.WorkflowSection
 */
export enum WorkflowSection {
  /**
   * @generated from enum value: WORKFLOW_SECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_SECTION_TOMORROW = 1;
   */
  TOMORROW = 1,

  /**
   * @generated from enum value: WORKFLOW_SECTION_DAY_AFTER_TOMORROW = 2;
   */
  DAY_AFTER_TOMORROW = 2,

  /**
   * @generated from enum value: WORKFLOW_SECTION_WEEKLY = 3;
   */
  WEEKLY = 3,

  /**
   * @generated from enum value: WORKFLOW_SECTION_MONTHLY = 4;
   */
  MONTHLY = 4,

  /**
   * @generated from enum value: WORKFLOW_SECTION_ANNUAL = 5;
   */
  ANNUAL = 5,

  /**
   * 当日
   *
   * @generated from enum value: WORKFLOW_SECTION_TODAY = 6;
   */
  TODAY = 6,

  /**
   * 単日。新規の雛形・ケースはこの値を使い、旧 3 値は既存データの読取互換として残す。
   *
   * @generated from enum value: WORKFLOW_SECTION_SINGLE_DAY = 7;
   */
  SINGLE_DAY = 7,
}

/**
 * Describes the enum bffuser.v1.WorkflowSection.
 */
export const WorkflowSectionSchema: GenEnum<WorkflowSection> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_template_model, 1);

/**
 * DemandAutoConfirmMethod mirrors internalapi.v1.DemandAutoConfirmMethod.
 *
 * @generated from enum bffuser.v1.DemandAutoConfirmMethod
 */
export enum DemandAutoConfirmMethod {
  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_PREV_DAY_COPY = 1;
   */
  PREV_DAY_COPY = 1,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_SAME_WEEKDAY_CATEGORY_PREV_WEEK_COPY = 2;
   */
  SAME_WEEKDAY_CATEGORY_PREV_WEEK_COPY = 2,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_WEIGHTED_MOVING_AVG = 3;
   */
  WEIGHTED_MOVING_AVG = 3,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_SAME_WEEKDAY_CATEGORY_WEIGHTED_AVG = 4;
   */
  SAME_WEEKDAY_CATEGORY_WEIGHTED_AVG = 4,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_SAME_WEEKDAY_PREV_WEEK_COPY = 5;
   */
  SAME_WEEKDAY_PREV_WEEK_COPY = 5,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_ACTUAL_TREND_CORRECTION = 6;
   */
  ACTUAL_TREND_CORRECTION = 6,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_EXTERNAL_JWA = 7;
   */
  EXTERNAL_JWA = 7,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_EXTERNAL_DEMAND_AI = 8;
   */
  EXTERNAL_DEMAND_AI = 8,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_EXTERNAL_METERLINK = 9;
   */
  EXTERNAL_METERLINK = 9,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_EXTERNAL_LOADNAVI = 10;
   */
  EXTERNAL_LOADNAVI = 10,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_EXTERNAL_ENSEMBLE_LAB = 11;
   */
  EXTERNAL_ENSEMBLE_LAB = 11,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_IN_HOUSE_ENGINE = 12;
   */
  IN_HOUSE_ENGINE = 12,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_WEEKLY_PREV_WEEK_COPY = 13;
   */
  WEEKLY_PREV_WEEK_COPY = 13,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_MONTHLY_PLAN_COPY = 14;
   */
  MONTHLY_PLAN_COPY = 14,

  /**
   * @generated from enum value: DEMAND_AUTO_CONFIRM_METHOD_CSV_REGISTERED_VALUES = 15;
   */
  CSV_REGISTERED_VALUES = 15,
}

/**
 * Describes the enum bffuser.v1.DemandAutoConfirmMethod.
 */
export const DemandAutoConfirmMethodSchema: GenEnum<DemandAutoConfirmMethod> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_template_model, 2);

/**
 * LinkedPageKind identifies the application page a sub-step links to.
 * UNSPECIFIED means the sub-step has no associated link (= link hidden).
 * Values map 1:1 to routePaths keys in the frontend.
 * Mirrors internalapi.v1.LinkedPageKind.
 *
 * @generated from enum bffuser.v1.LinkedPageKind
 */
export enum LinkedPageKind {
  /**
   * @generated from enum value: LINKED_PAGE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_WORKFLOW_CASES = 1;
   */
  WORKFLOW_CASES = 1,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_DEMAND_ACTUAL_STATISTICS = 2;
   */
  DEMAND_ACTUAL_STATISTICS = 2,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_SUPPLY_GAP = 4;
   */
  SUPPLY_GAP = 4,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_SUPPLY_BILATERAL = 5;
   */
  SUPPLY_BILATERAL = 5,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_NOTIFICATION_CHANGE = 6;
   */
  ADMIN_NOTIFICATION_CHANGE = 6,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_SUPPLY_PLANT = 7;
   */
  SUPPLY_PLANT = 7,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_SUPPLY_48DATA = 8;
   */
  SUPPLY_48DATA = 8,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_INDIRECT_TRANSMISSION = 9;
   */
  ADMIN_INDIRECT_TRANSMISSION = 9,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_SUPPLY_RENEW_FORECAST = 10;
   */
  SUPPLY_RENEW_FORECAST = 10,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_FIP_PREMIUM = 11;
   */
  ADMIN_FIP_PREMIUM = 11,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_BIDDING_SPOT = 12;
   */
  BIDDING_SPOT = 12,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_BIDDING_INTRADAY = 13;
   */
  BIDDING_INTRADAY = 13,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_BID_LIMITS = 14;
   */
  ADMIN_BID_LIMITS = 14,

  /**
   * Deprecated: 選択肢からは除外済み。 過去 tenant overlay data 互換のため
   * enum 定義のみ残置する。 新規選択は LINKED_PAGE_KIND_SUBMISSION_MANAGEMENT を使う
   * (workflow-templates-linked-page-spec-compliance §4)。
   *
   * @generated from enum value: LINKED_PAGE_KIND_PLAN_SUBMISSION = 15;
   */
  PLAN_SUBMISSION = 15,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_PLAN_PROCUREMENT = 16;
   */
  PLAN_PROCUREMENT = 16,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_PLAN_GEN_SALES = 17;
   */
  PLAN_GEN_SALES = 17,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_PLAN_DEMAND_SUPPRESSION = 18;
   */
  PLAN_DEMAND_SUPPRESSION = 18,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_BALANCE_DEMAND = 19;
   */
  BALANCE_DEMAND = 19,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_BALANCE_GENERATION = 20;
   */
  BALANCE_GENERATION = 20,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_REVENUE_FORECAST = 21;
   */
  REVENUE_FORECAST = 21,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_REVENUE_INVOICE = 22;
   */
  REVENUE_INVOICE = 22,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_WEATHER_FORECAST = 23;
   */
  WEATHER_FORECAST = 23,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_DEMAND_FORECAST_DAILY = 24;
   */
  DEMAND_FORECAST_DAILY = 24,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_DASHBOARD = 25;
   */
  DASHBOARD = 25,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_CUSTOMER_CONTRACT = 26;
   */
  CUSTOMER_CONTRACT = 26,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_CUSTOMER_RATE = 27;
   */
  CUSTOMER_RATE = 27,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_CUSTOMER_SCHEDULE = 28;
   */
  CUSTOMER_SCHEDULE = 28,

  /**
   * 提出管理 (spec workflow-templates.md §機能詳細 4a / §サブステップ リンク先画面一覧)。
   * 「計画提出」 メインカテゴリのリンク先。 新規選択はこの kind を使い、
   * deprecated LINKED_PAGE_KIND_PLAN_SUBMISSION は overlay 互換のみに残す。
   *
   * @generated from enum value: LINKED_PAGE_KIND_SUBMISSION_MANAGEMENT = 29;
   */
  SUBMISSION_MANAGEMENT = 29,

  /**
   * 追加: workflow-template-linked-page-8categories (2026-08-03 PdM 判断)
   * spec §サブステップ リンク先画面一覧 (P0) の 8 カテゴリ拡張で不足していた kind。
   * 旧 LINKED_PAGE_KIND_WEATHER_FORECAST は overlay 互換のため定義を残置するが、
   * 新規選択は ADMIN_WEATHER_FORECAST_POINTS を使う。
   *
   * @generated from enum value: LINKED_PAGE_KIND_DEMAND_SINGULAR_DAY = 30;
   */
  DEMAND_SINGULAR_DAY = 30,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_BALANCE_IMPUTATION_POLICY = 31;
   */
  BALANCE_IMPUTATION_POLICY = 31,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_PLAN_SPLIT_SUPPLY = 32;
   */
  PLAN_SPLIT_SUPPLY = 32,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_UPLOADS = 33;
   */
  ADMIN_UPLOADS = 33,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_OCCTO = 34;
   */
  ADMIN_OCCTO = 34,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_ESLJ_ACCOUNTS = 35;
   */
  ADMIN_ESLJ_ACCOUNTS = 35,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_WEATHER_FORECAST_POINTS = 36;
   */
  ADMIN_WEATHER_FORECAST_POINTS = 36,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_CUSTOMER_DEMAND_GROUPS = 37;
   */
  CUSTOMER_DEMAND_GROUPS = 37,

  /**
   * @generated from enum value: LINKED_PAGE_KIND_ADMIN_APPROVAL_FLOW = 38;
   */
  ADMIN_APPROVAL_FLOW = 38,

  /**
   * 発電所別 (同時同量) 画面。
   *
   * @generated from enum value: LINKED_PAGE_KIND_BALANCE_GENERATION_DETAIL = 39;
   */
  BALANCE_GENERATION_DETAIL = 39,
}

/**
 * Describes the enum bffuser.v1.LinkedPageKind.
 */
export const LinkedPageKindSchema: GenEnum<LinkedPageKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_template_model, 3);

/**
 * WorkflowTemplateErrorReason mirrors internalapi.v1.WorkflowTemplateErrorReason
 * 1:1 (same values, same numbers; pinned by the mirror test).
 *
 * @generated from enum bffuser.v1.WorkflowTemplateErrorReason
 */
export enum WorkflowTemplateErrorReason {
  /**
   * @generated from enum value: WORKFLOW_TEMPLATE_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The template cannot be deleted because workflow auto creation rules use
   * it (spec AC-WFT-061).
   *
   * @generated from enum value: WORKFLOW_TEMPLATE_ERROR_REASON_IN_USE_BY_AUTO_CREATION_RULE = 1;
   */
  IN_USE_BY_AUTO_CREATION_RULE = 1,
}

/**
 * Describes the enum bffuser.v1.WorkflowTemplateErrorReason.
 */
export const WorkflowTemplateErrorReasonSchema: GenEnum<WorkflowTemplateErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_workflow_template_model, 4);

